import {
  Switch,
  Route,
  useLocation,
  useHistory
} from "react-router-dom";

import {
  Home,
  About
} from "src/pages";
import { ClienteForm } from "./components/pagamento/clientes/ClienteForm";
import { path$ } from "./framework/store";
import { Agendamento } from "./pages/Agendamento";
import { Pagamento } from "./pages/Pagamento";
import { Page404 } from "./pages/Page404";

type ApplicationPathType = {
  path: string;
  params: string[];
  page: any;
}

type PathObjectType = { [key: string]: ApplicationPathType }

const PATHS: PathObjectType = {
  "home": {
    path: "/",
    params: [":params?"],
    page: Home
  },
  "pagamento": {
    path: "/etapa/pagamento",
    params: [],
    page: Pagamento
  },
  "sobre": {
    path: "/sobre",
    params: [],
    page: About
  },
  "not_found": {
    path: "/not-found",
    params: [],
    page: Page404
  },
  "etapa_cliente": {
    path: "/etapa/cliente",
    params: [],
    page: ClienteForm
  },
  "bar_code": {
    path: "/bar-code",
    params: [],
    page: About
  },
  "agendamento": {
    path: "/agendamentos",
    params: [],
    page: Agendamento
  },
}


export default function Routes() {
  const location = useLocation();
  const history = useHistory();

  const getPaths = () => {
    const keys = Object.keys(PATHS);
    const _paths: string[] = [];

    for (let key of keys) {
      _paths.push(PATHS[key].path);
    }

    return _paths;
  }

  if (!getPaths().includes(location.pathname)) {
    path$.next(location as any)
    history.push(PATHS.not_found.path);
  }

  return (
    <Switch>
      <Route exact path={PATHS.home.path} component={PATHS.home.page} />
      <Route exact path={PATHS.sobre.path} component={PATHS.sobre.page} />
      <Route exact path={PATHS.pagamento.path} component={PATHS.pagamento.page} />
      <Route exact path={PATHS.not_found.path} component={PATHS.not_found.page} />
      <Route exact path={PATHS.etapa_cliente.path} component={PATHS.etapa_cliente.page} />
      <Route exact path={PATHS.agendamento.path} component={PATHS.agendamento.page} />
    </Switch>
  );
}
